import Button from 'components/Button'
import Drawer from 'components/Drawer'
import styled from 'styled-components'
import { FONT } from 'theme/font'

export const CustomStyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0px 30px 30px 30px;
  }
`
export const DrivesButton = styled(Button.Secondary)`
  font-weight: ${FONT.FW_600};
`

export const TopHeader = styled.div`
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1000;
`

export const HeaderItem = styled.div`
  display: flex;
  justify-content: space-between;
`
export const HeaderRightItem = styled.div`
  display: flex;
  gap: 7rem;
  padding-top: 10px;
`
export const SubHeaderItem = styled.div`
  color: #343e59;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
`
export const SubContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`
export const SubPara = styled.p`
  color: #4d566e;
  font-size: 14px;
  font-weight: 500;
  width: 300px;
  overflow-wrap: break-word;
  text-transform: capitalize;
`
export const RightHeaderItem = styled.div`
  color: '#343E59s';
  font-size: 14px;
  font-weight: 700;
`
export const LeftHeaderItem = styled.div`
  padding-top: 10px;
  color: '#343E59s';
  font-size: 14px;
  font-weight: 700;
`

export const ParaHead = styled.div`
  gap: 20px;
  align-items: center;
`
export const ParaText = styled.div`
  font-size: 14px;
  color: #808697;
  font-weight: 600;
`
export const CheckboxItem = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #808697;
  font-weight: 600;
`
export const IconPointer = styled.div`
  cursor: pointer;
`
export const ListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
export const ListHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const LisSubtHead = styled.div`
  display: flex;
  justify-content: space-between;
`
